import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const pagesStrings = new LocalizedStrings({
  en: {
    userMenu: {
      myDocuments: "My Documents",
      logout: "Logout"
    }
  }
});

export default withCommon<typeof pagesStrings>(pagesStrings);
